import { Div } from '../../../base/components/native/div'
import { IProductVariant } from '../../../interfaces/product'

export const ProductPrice = (price: string = '...') => {

    const base = Div('From € ' + price)
    base.cssClass({
        color: 'gray'
    })

    return Object.assign(base, {
        update: (variant: IProductVariant) => {
            base.el.innerHTML = 'From € ' + variant.price
        }
    })
}